import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'

const RecentMatchesVenue = ({ data }) => {
  function formatDate(timestamp) {
    const date = new Date(timestamp)
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }
    return date.toLocaleString('en-US', options)
  }
  return (
    <>
      <h6>Recent Matches on Venue</h6>
      <div className="common-box">
        <div className='d-flex flex-column'>
          {data?.aPreviousMatches ? data?.aPreviousMatches.map((match, index) => {
            return (<>
              <div className='d-flex flex-row justify-content-between mx-0 mx-md-2' key={index}>
                <div className={`${styles.box} align-items-start ${styles.scoreHeading}`}>
                  <span className={`${styles.country}`}>{match?.oTeamScoreA?.oTeam?.sAbbr}</span>
                  <span>{match?.oTeamScoreA?.sScores} <span className={styles.score}></span>{` (${match?.oTeamScoreA?.sOvers} ov)`}</span>
                </div>
                <div className={`d-flex flex-column gap-1 align-items-center ${styles.scoreHeading}`} style={{ color: '#888888' }}>
                  <span className={`${styles.country}`} style={{ fontWeight: '600' }}>
                    {match?.iWinnerId === match?.oTeamScoreA?.iTeamId ? match?.oTeamScoreA?.oTeam?.sAbbr : match?.iWinnerId === match?.oTeamScoreB?.iTeamId ? match?.oTeamScoreB?.oTeam?.sAbbr : ''}{' '}
                    Won</span>
                  <span className={styles.smallText}>{`${match?.sSubtitle}  ${formatDate(match?.dStartDate)} `}</span>
                </div>
                <div className={`${styles.box} align-items-end ${styles.scoreHeading}`}>
                  <span className={`${styles.country}`}>{match?.oTeamScoreB?.oTeam?.sAbbr}</span>
                  <span>{match?.oTeamScoreB?.sScores}<span className={styles.score}></span>{` (${match?.oTeamScoreB?.sOvers} ov)`}</span>
                </div>
              </div>
              {!(index === data?.aPreviousMatches.length - 1) && <div className={styles.line}></div>}
            </>
            )
          }) : ''}
        </div>
      </div>
    </>
  )
}

RecentMatchesVenue.propTypes = {
  data: PropTypes.array.isRequired
}

export default RecentMatchesVenue
